import request from "@/utils/request";

export function getHomeList() {
    return request({
        url: '/device/homeList',
        method: 'get',
        params: {'pageSize':1000}
    })
}